import { useMutation, useQueryClient } from '@tanstack/react-query';

import { JobRepository, SubmitCustomerJobRequestData } from 'domain/repositories/IJobRepository';
import { useHookInjection } from 'application/hooks';

import { QUERY_PREFIX as CUSTOMER_JOBS_QUERY_PREFIX } from './useCaseSearchCustomerJobs';

export default function useCaseSubmitCustomerJobRequest() {
  const queryClient = useQueryClient();

  const { submitCustomerJobRequest } = useHookInjection<JobRepository>(JobRepository);
  const { mutateAsync, isPending } = useMutation<void, Error, SubmitCustomerJobRequestData>({
    mutationFn: submitCustomerJobRequest,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CUSTOMER_JOBS_QUERY_PREFIX] });
    },
  });
  return {
    submitCustomerJobRequest: mutateAsync,
    isPending,
  };
}
